export default __webpack_public_path__ + "static/media/hr-3.5a823b8c.png";